import {
  BaseHeader,
  EmptyHeader,
  SortableHeader,
  SummaryTitleHeader,
  TitleHeader,
} from 'features/dashboard/table/column/DashboardHeaders'
import {
  CampaignTypeCell,
  DateCell,
  IdCell,
  OperationStatusCell,
} from 'features/dashboard/table/column/DashboardCells'
import {
  BizChannelCell,
  CampaignDailyBudgetCell,
  CampaignNameCell,
  CampaignPeriodCell,
} from 'features/dashboard/table/column/campaign/CampaignCells'
import {
  metricColumns,
  selectionColumn,
  statusColumn,
} from 'features/dashboard/table/column/DashboardColumns'
import { EtcColumns, GeneralColumns } from '../../../../Columns'

/**
 * @file 캠페인 테이블 칼럼
 * @see https://wiki.daumkakao.com/pages/viewpage.action?pageId=814145935
 */

export const CampaignFixedColumns = [
  selectionColumn,
  {
    accessor: 'name',
    sticky: 'left',
    Header: TitleHeader,
    columns: [
      {
        accessor: 'name',
        width: 370,
        Header: SummaryTitleHeader,
        Cell: CampaignNameCell,
      },
    ],
  },
  statusColumn,
]

export const CampaignConfigurableColumns = [
  {
    accessor: GeneralColumns.operationStatus.name,
    Header: BaseHeader,
    title: GeneralColumns.operationStatus.displayName,
    tooltip: (
      <>
        캠페인의 게재와 관련된 현재 상태를 의미합니다.
        <br />
        상위 광고계정의 상태를 고려하여 현재 캠페인의 최종 운영 상태를
        표기합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.operationStatus.name,
        width: 180,
        Header: EmptyHeader,
        Cell: OperationStatusCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.campaignType.name,
    Header: SortableHeader,
    title: GeneralColumns.campaignType.displayName,
    tooltip:
      '캠페인 유형을 통하여 원하는 목표를 달성하는데 적합한 캠페인, 광고그룹, 키워드, 소재 설정을 제공합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaignType.name,
        width: 130,
        Header: EmptyHeader,
        Cell: CampaignTypeCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.bizChannel.name,
    Header: BaseHeader,
    title: GeneralColumns.bizChannel.displayName,
    tooltip: '캠페인에 연결된 비즈채널정보를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.bizChannel.name,
        width: 230,
        Header: EmptyHeader,
        Cell: BizChannelCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.dailyBudget.name,
    Header: SortableHeader,
    title: GeneralColumns.dailyBudget.displayName,
    tooltip: '캠페인에 설정된 일예산을 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.dailyBudget.name,
        width: 100,
        Header: EmptyHeader,
        Cell: CampaignDailyBudgetCell,
      },
    ],
  },
  {
    accessor: GeneralColumns.impressionDate.name,
    Header: BaseHeader,
    title: GeneralColumns.impressionDate.displayName,
    tooltip: (
      <>
        캠페인 하위 광고그룹(삭제 제외)의 가장 빠른 시작일부터
        <br />
        가장 늦은 종료일을 의미합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.impressionDate.name,
        width: 190,
        Header: EmptyHeader,
        Cell: CampaignPeriodCell,
      },
    ],
  },
  {
    accessor: EtcColumns.campaignId.name,
    Header: SortableHeader,
    title: EtcColumns.campaignId.displayName,
    tooltip: '캠페인 마다 부여된 고유의 식별값을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.campaignId.name,
        width: 160,
        Header: EmptyHeader,
        Cell: IdCell,
      },
    ],
  },
  {
    accessor: EtcColumns.createdDate.name,
    Header: SortableHeader,
    title: EtcColumns.createdDate.displayName,
    tooltip: '캠페인이 최초 등록된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.createdDate.name,
        width: 130,
        Header: EmptyHeader,
        Cell: DateCell,
      },
    ],
  },
  {
    accessor: EtcColumns.updatedDate.name,
    Header: SortableHeader,
    title: EtcColumns.updatedDate.displayName,
    tooltip: '캠페인이 최종 수정된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.updatedDate.name,
        width: 130,
        Header: EmptyHeader,
        Cell: DateCell,
      },
    ],
  },
  ...metricColumns,
]
